import { IDropdownOption } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import {
    createProductCountByModel, createUserProductFilterModel, HomePageLinkFilterModel,
    HomePageLinkType,
    ProductCountByModel, ProductKeyModel, ShortLineModel, UserProductFilterModel
} from "../models/ProductModel";
import { ProductUtils } from "../ProductUtils";
import { UserProductLineService } from "../services/UserProductLineService";

export default function useProductVM(linkToProductModel: HomePageLinkFilterModel) {
    const service = new UserProductLineService();

    const [lines, setLines] = useState<ShortLineModel[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<ProductKeyModel | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [countDict, setCountDict] = useState<ProductCountByModel>(createProductCountByModel());
    const [listHash, setListHash] = useState(Utils.getRandomKey());
    const [pageHash, setPageHash] = useState<number>(Utils.getRandomKey());

    const [loading, setLoading] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showAllBrand, setShowAllBrands] = useState(false);

    const [brandOptions, setBrandOptions] = useState<IDropdownOption[]>([]);
    const [sizeOptions, setSizeOptions] = useState<IDropdownOption[]>([]);

    const {
        form: filter,
        setForm: setFilter,
        resetForm: resetFilter,
        setField: setFilterField
    } = useForm<UserProductFilterModel>(createUserProductFilterModel());

    const {
        form: tempFilter,
        setForm: tempSetFilter,
        resetForm: tempResetFilter,
        setField: tempSetFilterField
    } = useForm<UserProductFilterModel>(createUserProductFilterModel());

    const onLoad = () => {
        if (linkToProductModel.type !== HomePageLinkType.none) {
            getFilterModel();
        } else {
            getList(false);
            getListCount(filter);
        }

        ProductUtils.getBrandOptions((list: IDropdownOption[]) => setBrandOptions(list));
        ProductUtils.getSizeOptions((list: IDropdownOption[]) => setSizeOptions(list));
    }

    const getFilterModel = () => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                var newFilter = result.data;

                if (Utils.isNull(newFilter)) newFilter = createUserProductFilterModel();
                if (newFilter.PageNumber < 1) newFilter.PageNumber = 1;
                if (newFilter.PageSize <= 0) newFilter.PageSize = DataUtils.PAGE_SIZE;

                setFilter(newFilter);

                getListWithFilter(newFilter);
                getListCount(newFilter);
            }
        }

        let request = service.getFilters(linkToProductModel);
        DataUtils.onRequest(request, onResult);
    }

    const getList = (pageChange = false) => {
        getListWithFilter(filter, pageChange);
    }

    const getListWithFilter = (newFilter: UserProductFilterModel, pageChange = false) => {
        setFilter(newFilter);

        setLoading(true);
        setListHash(Utils.getRandomKey());
        setLines([]);

        const request = service.search(newFilter);

        DataUtils.onRequest(
            request,
            (result: IDataResult) => getListResult(result, pageChange)
        );
    }

    const getListResult = (result: IDataResult, pageChange = false) => {
        if (result.status === ResponseStatus.success) {
            setLines(result.data.items);
            setTotalCount(result.data.totalCount);
            setListHash(Utils.getRandomKey());

            if (!pageChange) {
                setPageHash(Utils.getRandomKey());
            }
        }

        setLoading(false);
    }

    const getListCount = (newFilter: UserProductFilterModel) => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setCountDict(result.data);
            }
        }

        const request = service.getListCount(newFilter);
        DataUtils.onRequest(request, onResult);
    }

    return {
        lines, setLines,
        selectedProduct, setSelectedProduct,
        totalCount,
        countDict,
        listHash,
        pageHash,

        loading, setLoading,
        showFilter, setShowFilter,
        showDetail, setShowDetail,
        showAllBrand, setShowAllBrands,

        brandOptions,
        sizeOptions,

        filter, setFilter, resetFilter, setFilterField,
        tempFilter, tempSetFilter, tempResetFilter, tempSetFilterField,

        onLoad,
        getFilterModel,
        getList,
        getListWithFilter,
        getListCount
    }
}